import './App.css';
import AIAssistant from './components/chatbot.jsx';

function App() {
  return (
    <div className="App">
      
      <div style={{ maxWidth: 400, margin: '40px auto' }}>
        <AIAssistant />
      </div>
    </div>
  );
}

export default App;
